import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicInventory({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.6 8.8a1 1 0 011 1v3.8a1 1 0 01-1 1H9.8a1 1 0 01-1-1V9.8a1 1 0 011-1h3.8zm-7.3 0a1 1 0 011 1v3.8a1 1 0 01-1 1H2.5a1 1 0 01-1-1V9.8a1 1 0 011-1h3.8zm6.8 1.5h-2.8v2.8h2.8v-2.8zm-7.3 0H3v2.8h2.8v-2.8zm.5-9a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4zm7.3.2a1 1 0 011 1v3.8a1 1 0 01-1 1H9.8a1 1 0 01-1-1V2.5a1 1 0 011-1h3.8zM13.1 3h-2.8v2.8h2.8V3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicInventory.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicInventory.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicInventory svgRef={ref} {...props} />);
export default ForwardRef;
